import { createContext, useState, useEffect } from 'react';
import helpers from '../helpers';
let { usePrevious, deepEqual } = helpers;
const baseurl = process.env.REACT_APP_API_URL ;
let fireStore = {
   context: createContext(null),
   Provider: ({ children }) => {
      let [totalGrants, setTotalGrants] = useState(5);
      let [firestoreGrants, setFirestoreGrants] = useState();
      let [useFirestoreGrants, setUseFirestoreGrants] = useState(true);

      let lastNumberOfTotalGrants = usePrevious(totalGrants);
      let numberOfGrantsChanged = totalGrants !== lastNumberOfTotalGrants;

      let lastFirestoreGrants = usePrevious(firestoreGrants);
      let firestoreGrantsUpdated = !deepEqual(
         firestoreGrants,
         lastFirestoreGrants
      );

      if (firestoreGrantsUpdated) {
         console.log('firestore updated');
      }

      useEffect(() => {
         if (numberOfGrantsChanged) {
            fetch(`${baseurl}/api/getfirestoregrants`, {
               method: 'post',
               body: JSON.stringify({
                  start: totalGrants - 5,
                  limit: 5,
               }),
            })
               .then(res => res.json())
               .then(res => {
                  addFirestoreGrants(res.docs);
               })
               .catch(err => {
                  console.log(err);
               });
         }
      }, [totalGrants, firestoreGrants, numberOfGrantsChanged]);
      return (
         <fireStore.context.Provider
            value={{
               numberOfGrantsChanged: numberOfGrantsChanged,
               useFirestoreGrants: useFirestoreGrants,
               setUseFirestoreGrants: setUseFirestoreGrants,
               firestoreGrants: firestoreGrants,
               firestoreGrantsUpdated: firestoreGrantsUpdated,
               loadMoreFirestoreGrants: loadMoreFirestoreGrants,
            }}
         >
            {children}
         </fireStore.context.Provider>
      );

      function addFirestoreGrants(grants) {
         if (firestoreGrants) {
            let firestoreGrantsBuffer = JSON.parse(
               JSON.stringify(firestoreGrants)
            );
            grants.forEach((grant, i) => {
               firestoreGrantsBuffer.push(grant);
            });

            setFirestoreGrants(firestoreGrantsBuffer);
         } else {
            setFirestoreGrants(grants);
         }
      }

      function loadMoreFirestoreGrants() {
         setTotalGrants(totalGrants + 5);
      }
   },
};

export default fireStore;



